import React from 'react';
import ContractDashboard from 'components/app/crm/dashboard/contracts/ContractDashboard';

const ContractDashboardPage = () => <ContractDashboard />;

export default ContractDashboardPage;
